const initialState = {
  id:null,
  acc_type:"",
  acc_name:"",
  acc_id:null,
  activatedAvailable:false,
  is_prop:null,
  acc_level:null,
  can_trade: true
};

const account = (state = initialState, action) => {
  switch (action.type) {
      case "select_account":
        return {
          id:action.payload.id,
          acc_type:action.payload.acc_type,
          acc_name:action.payload.acc_name,
          acc_id:action.payload.acc_id,
          activatedAvailable:action.payload.activatedAvailable,
          is_prop:action.payload.is_prop,
          acc_level:action.payload.acc_level,
          can_trade:action.payload.can_trade
        };
      default:
        return state;
    }
}

export default account